import React from 'react'
import { Row, Col } from 'antd'
import { EditSaveButton, GraviButton } from '@gravitate-js/excalibrr'
import { LoadingOutlined } from '@ant-design/icons'

export const EditAndSaveControls = ({ loading, canEditStores, editing, setEditing, setLoading }) => {
  return (
    <>
      <Row>
        {!loading ? (
          <Col span={24} align='right'>
            {canEditStores && (
              <EditSaveButton
                editing={editing}
                onEdit={() => {
                  setEditing(true)
                  setLoading(false)
                }}
              />
            )}
          </Col>
        ) : (
          <Col align='right' span={24}>
            <LoadingOutlined />
          </Col>
        )}
      </Row>
      {editing && (
        <Row flex={1} justify='end' className='pt-2'>
          <Col>
            <GraviButton
              theme2
              appearance='outline'
              buttonText='Cancel'
              onClick={() => setEditing(false)}
              style={{ marginTop: '2%' }}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
